import { render, staticRenderFns } from "./BookLandingPage.vue?vue&type=template&id=6345e346&scoped=true"
import script from "./BookLandingPage.vue?vue&type=script&lang=js"
export * from "./BookLandingPage.vue?vue&type=script&lang=js"
import style0 from "./BookLandingPage.vue?vue&type=style&index=0&id=6345e346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345e346",
  null
  
)

export default component.exports